"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyRulesToProps = void 0;
var lodash_1 = require("lodash");
var hasAllPropsWithValues_1 = require("./hasAllPropsWithValues");
var applyRulesToProps = function () {
    var propRules = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        propRules[_i] = arguments[_i];
    }
    return function (obj, defaultReturn) {
        if (defaultReturn === void 0) { defaultReturn = undefined; }
        var hasEm = hasAllPropsWithValues_1.hasAllPropsWithValues(obj);
        return lodash_1.flow(function (rules) { return lodash_1.find(rules, function (p) {
            var props = p.props;
            return hasEm.apply(void 0, [].concat(props));
        }); }, function (propRule) {
            return propRule && propRule.rule ? propRule.rule(obj) : defaultReturn;
        })(propRules);
    };
};
exports.applyRulesToProps = applyRulesToProps;
//# sourceMappingURL=applyRulesToProps.js.map